export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];
export const VIDEO_EXTENSIONS = ['mp4', 'mov', 'avi', 'webm', 'wmv'];
